import script from "./TitledSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./TitledSection.vue?vue&type=script&lang=ts&setup=true"

import "./TitledSection.vue?vue&type=style&index=0&id=936adb2e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-936adb2e"]])

export default __exports__